module.exports = __webpack_public_path__ + "images/f867b7e66fbc097861eb7504e55f23eb-silver_badge.png";